// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ExecutingTypeDefinition_abstract } from './../../abstract/SagaBase/Objects/ExecutingTypeDefinition_abstract';
export class ExecutingTypeDefinition extends ExecutingTypeDefinition_abstract {}
